import { headers } from "../../../App/Axios"
import HTTPService from "../../../App/HTTPService"


export const getEventsRequest = async (roomId: number, pageNumber: number, query: string, orgId?: number) => {
    if (orgId) {

        const response = await HTTPService.get(`/room/${roomId}/events?page=${pageNumber}&query=${query}&orgId=${orgId}`, headers)
        return response
    }
    else {
        const response = await HTTPService.get(`/room/${roomId}/events?page=${pageNumber}&query=${query}`, headers)
        return response
    }
}

export const getEventRequest = async (eventId: number) => {
    const response = await HTTPService.get(`/room/events/${eventId}`, headers)
    return response
}

export const createEventRequest = async (roomId: number, data: FormData) => {
    const response = await HTTPService.post(`/room/${roomId}/events/`, data, headers)
    return response
}

export const updateEventRequest = async (roomId: number, eventId: number, data: any,orgId?: number) => {
    if(orgId){
        const response = await HTTPService.patch(`/room/${roomId}/events/${eventId}?orgId=${orgId}`, data, headers)
        return response
    } else {
        const response = await HTTPService.patch(`/room/${roomId}/events/${eventId}`, data, headers)
        return response
    }
}

export const deleteEventRequest = async (roomId: number, eventId: number, orgId?: number) => {
    const url = orgId ? `/room/${roomId}/events/${eventId}?orgId=${orgId}` : `/room/${roomId}/events/${eventId}`;
    const response = await HTTPService.delete(url, headers);
    return response
}

export const exportEventRequest = async (roomId: number, eventId: number) => {
    const response = await HTTPService.get(`/room/${roomId}/events/${eventId}/export`, {
        ...headers,
        responseType: 'blob', // Ensures the response is treated as a file
    })
    return response
}